import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
// import { info } from 'console';
import { map } from "rxjs/operators";
import * as $ from 'jquery';
import { Observable } from 'rxjs';
import { AuthPayloadService } from '../services/auth-payload';
import { environment } from '../../environments/environment';


@Component({
  selector: 'app-drugs-covered-by-the-program',
  standalone: false,
  templateUrl: './drugs-covered-by-the-program.component.html',
  styleUrls: ['./drugs-covered-by-the-program.component.scss']
})
export class DrugsCoveredByTheProgramComponent implements OnInit {

  details: any;

  GeoBaseURL: string = "https://maps.googleapis.com/maps/api/geocode/json?";
  BaseURL2: string = "https://mysql-hdrx.23byt.es/api/v2/";
  BaseURL3: string = "https://mysql-hdrx.23byt.es/api/v3/";

  loading: Boolean = true;

  constructor(public http: HttpClient, private authPayloadService: AuthPayloadService) { }

  // GetCoordinatebyzip() {
  //   let headers = new Headers();
  //   headers.append(
  //     "Content-Type",
  //     "application/x-www-form-urlencoded; charset=utf-8"
  //   );
  //   return this.http.post(

  //     this.BaseURL3 + "GetDrugList",
  //     "stext=" + "GlicRx",
  //     {
  //       headers: headers
  //     }
  //   );
  // }

  GetCoordinatebyzip(): Observable<any> {
    const authPayload = this.authPayloadService.generatePayload();
    const bodyData = 'stext=GlicRx' + '&challenge=' + authPayload.challenge + '&timestamp=' + authPayload.timestamp + '&nonce=' + authPayload.nonce + '&signature=' + authPayload.signature + '&appname=' + authPayload.appname;
    return this.http.post(environment.api.baseUrl + "GetDrugList", bodyData, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
  }

  ngOnInit() {
    this.GetCoordinatebyzip()
      // .pipe(map((res) => res.json()))
      .subscribe((data: any) => {
        this.details = data;
        this.loading = false;
      });
  }

  scroll(id) {
    let el = document.getElementById(id);
    $(".active").removeClass('active');
    (id == "#") ? $('.character.num').addClass('active') : $('.character.' + id).addClass('active');
    el.scrollIntoView();
  }

}
